/* Almla redesign: the /cart page (sections/alm-cart-page.liquid).
   The qty and remove links work on their own (/cart/change); this turns them
   into Ajax changes and redraws the section in place, keeps the header count
   and the cart drawer in step, and redraws the page when the drawer closes
   after changing the cart there. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var busy = false;
  function el() { return document.querySelector("[data-acp]"); }

  // The drawer's value props (header setting), so they are edited in one place.
  function props() {
    var to = document.querySelector("[data-acp-props]");
    var from = document.querySelector("#almCd .acd-props");
    if (!to || !from) return;
    to.innerHTML = from.innerHTML;
    to.hidden = false;
  }

  function redraw() {
    var cur = el();
    if (!cur) return Promise.resolve();
    return fetch(ROOT + "cart?section_id=" + encodeURIComponent(cur.getAttribute("data-section")), { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, "text/html").querySelector("[data-acp]");
        if (!next) return;
        cur.replaceWith(next);
        props();
      });
  }

  function fail(msg) {
    var e = document.querySelector("[data-acp-err]");
    if (!e) return;
    e.textContent = msg || "That change could not be made. Please try again.";
    e.hidden = false;
  }

  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("[data-acp] [data-acp-q]");
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    e.preventDefault();
    if (busy) return;
    var li = a.closest("[data-acp-key]");
    if (!li) return;
    busy = true;
    li.classList.add("is-busy");
    fetch(ROOT + "cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: li.getAttribute("data-acp-key"), quantity: +a.getAttribute("data-acp-q") })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return redraw(); })
      .then(function () { if (window.AlmCart) AlmCart.refresh(); })
      .catch(function (x) {
        li.classList.remove("is-busy");
        fail(x && (x.description || x.message));
      })
      .then(function () { busy = false; });
  });

  // Changes made in the drawer (qty, remove, "You may also like") show here
  // once it closes.
  var open = document.documentElement.classList.contains("acd-open");
  new MutationObserver(function () {
    var now = document.documentElement.classList.contains("acd-open");
    if (open && !now) redraw();
    open = now;
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

  props();
})();
